import { render, staticRenderFns } from "./ResourceManager.vue?vue&type=template&id=1d1d97de&scoped=true&"
import script from "./ResourceManager.vue?vue&type=script&lang=js&"
export * from "./ResourceManager.vue?vue&type=script&lang=js&"
import style0 from "./ResourceManager.vue?vue&type=style&index=0&id=1d1d97de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1d97de",
  null
  
)

export default component.exports